export const configuration = () => {
    const APP_ENV = process.env.REACT_APP_ENV || 'local';
    const localConfiguration = {
        baseURL: 'http://localhost:8080'
    }
    const devConfiguration = {
        baseURL: 'https://8dh319kzdf.execute-api.ap-south-1.amazonaws.com/dev'
    }
    const qaConfiguration = {
        baseURL: 'https://zusfrjmhal.execute-api.ap-south-1.amazonaws.com/qa'
    }
    const stgConfiguration = {
        baseURL: 'https://u2m6hljsi6.execute-api.ap-south-1.amazonaws.com/stg'
    }
    const prodConfiguration = {
        baseURL: 'https://gi3m0nkbf4.execute-api.ap-south-1.amazonaws.com/prod'
    }
    if (APP_ENV === 'local') {
        return localConfiguration;
    } else if (APP_ENV === 'dev') {
        return devConfiguration;
    } else if (APP_ENV === 'qa') {
        return qaConfiguration;
    } else if (APP_ENV === 'stg') {
        return stgConfiguration;
    } else if (APP_ENV === 'prod') {
        return prodConfiguration;
    }
}